import { createAsyncThunk } from '@reduxjs/toolkit';
import { errorGlobal } from '../reducers/notifications';
import { getAuthHeader } from '../../utils/tools';
import axios from 'axios';

export const getSubscription = createAsyncThunk(
    'payment/getSubscription',
    async (module = 'waste', { dispatch }) => {
        try {
            const request = await axios.get(`/api/payment/subscription?module=${module}`, getAuthHeader());
            return { module, data: request.data };
        } catch (error) {
            dispatch(errorGlobal('Nepodarilo sa načítať informácie o predplatnom.'));
            throw error;
        }
    }
);

export const getPaymentHistory = createAsyncThunk(
    'payment/getPaymentHistory',
    async (_, { dispatch }) => {
        try {
            const request = await axios.get('/api/payment/history', getAuthHeader());
            return request.data;
        } catch (error) {
            dispatch(errorGlobal('Nepodarilo sa načítať históriu platieb.'));
            throw error;
        }
    }
);

export const createPaymentIntent = createAsyncThunk(
    'payment/createPaymentIntent',
    async ({ plan, module = 'waste' }, { dispatch }) => {
        try {
            const request = await axios.post(
                '/api/payment/create-payment-intent',
                { plan, module },
                getAuthHeader()
            );
            return request.data;
        } catch (error) {
            dispatch(errorGlobal('Nepodarilo sa iniciovať platbu. Skúste znova.'));
            throw error;
        }
    }
);
